import ArticleSlider from '../components/ArticleSlider'
import ArticleVideo from '../components/ArticleVideo'

export default class Article {
    constructor() {
        new ArticleVideo()
        new ArticleSlider()
    }
}
